import React from "react";
import { useForm } from "react-hook-form";
import PropTypes from "prop-types";

import { yupResolver } from "@hookform/resolvers/yup";
import { Button } from "semantic-ui-react";
import { yup } from "utils";

import Form from "components/Form";

export function WealthboxForm({ loading, disabled, onSubmit }) {
  const wealthboxFormSchema = yup.object({
    accessToken: yup.string().required("Access token is required"),
  });

  const formProps = useForm({
    resolver: yupResolver(wealthboxFormSchema),
    defaultValues: { accessToken: "" },
    mode: "onSubmit",
    criteriaMode: "all",
  });

  return (
    <Form id="wealthbox-form" {...formProps} onSubmit={onSubmit}>
      <Form.Input
        name="accessToken"
        label="Access Token"
        fluid
        placeholder="Enter access token"
      />

      <div style={{ textAlign: "center" }}>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://app.crmworkspace.com/settings/access_tokens"
        >
          Log in to Wealthbox and retrieve your access token
        </a>
      </div>
      <Button
        primary
        fluid
        loading={loading}
        disabled={loading || disabled}
        style={{ marginTop: "20px" }}
      >
        Connect with Wealthbox
      </Button>
    </Form>
  );
}

WealthboxForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
};

WealthboxForm.defaultProps = {
  loading: false,
  disabled: false,
};

export default WealthboxForm;
